import log from 'client/lib/log';

import { SR_API_ACTION_GET_STATS } from 'api/actionTypes';

export default async function getStats({ apiClient }, { includePreReleaseLeads }) {
  let stats = {};
  try {
    stats = await apiClient.post(SR_API_ACTION_GET_STATS, { includePreReleaseLeads });
  } catch (error) {
    log.error(error);
  }
  return stats;
}
